<ul class="dropdown-menu">
    <li class="dropdown-menu__item">
        <button class="vector-map__tiles-btn btn-reset" aria-controls="map-tile-layers">
            <span data-map-layer-btn><%= layers[selected].tilejson.description %></span>
            <i class="icon icon-expand_more"></i>
        </button>
        <ul id="map-tile-layers" class="dropdown-menu__submenu" tabindex="-1" data-map-layer>
            <% for (var layerId in layers) { %>
                <li class="dropdown-menu__submenu-item">
                    <label class="label vector-map__tiles-choice">
                        <input type="radio" name="map_control_tiles" value="<%= layers[layerId].tilejson.name %>" <% if(selected === layers[layerId].tilejson.name) { %>checked<% } %>>
                        <%= layers[layerId].tilejson.description %>
                    </label>
                </li>
            <% } %>
        </div>
    </li>
</ul>


